
import React, { memo }  from 'react';

function  PrivacyPolicyComponent() {
  return (
    <>
      <div>
        <div className='content'>
          (주)문구야놀자은(는) 이용자들의 개인정보보호를 매우 중요시하며, 이용자가 회사의 서비스를 이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고 있습니다.
        </div>
      </div>

      <div>
        <div className='content'>
          이에 (주)문구야놀자는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한 개인정보보호지침을 준수하고 있습니다.
        </div>
      </div>

      <div>
        <div className='content'>
        (주)문구야놀자는 개인정보 처리방침을 통하여 이용자들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려 드립니다
        </div>
      </div>

      <div>
        <div className='content'>
          (주)문구야놀자는 개인정보 처리방침을 홈페이지 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다.
        </div>
      </div>

      <div>
        <div className='content'>
          회사의 개인정보 처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하는 경우나 개인정보 처리방침 변경될 경우 쇼핑몰의 첫페이지의 개인정보처리방침을 통해 고지하고 있습니다. 이용자들께서는 사이트 방문 시 수시로 확인하시기 바랍니다.
        </div>
      </div>

      <div>
        <div className='content'>
        ※ 만 13세 미만 회원에게 해당하지 않는 필수 서비스의 경우, 별도 개인정보를 수집 및 이용하지 않습니다.
        </div>
      </div>

      <div>
        <div className='content'>
        ※ 관계 법령에 따라 정보 및 기능성 메시지(결제 내역, 개인정보 처리 정기적 안내, 광고·마케팅 수신 동의 고지 등)를 보낼 수 있습니다. 이때 연락처를 통해 전송이 되며, 광고성 정보에 대한 것은 선택적으로 동의한 고객에게만 전송됩니다. 
        </div>
      </div>

      <div>
        <div className='content'>
          (주)문구야놀자의 개인정보 처리방침은 다음과 같은 내용을 담고 있습니다.<br />
          1. 공통 및 일반<br />
          2. 개인정보 수집에 대한 동의<br />
          3. 개인정보의 수집목적 및 이용목적<br />
          4. 수집하는 개인정보 항목 및 수집방법<br />
          5. 수집하는 개인정보의 보유 및 이용기간<br />
          6. 수집한 개인정보의 공유 및 제공<br />
          7. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항<br />
          8. 만 13세 미만 아동의 개인정보 처리에 관한 사항<br />
          9. 비회원 고객의 개인정보 관리<br />
          10. 개인정보의 위탁처리<br />
          11. 개인정보관련 의견수렴 및 불만처리에 관한 사항<br />
          12. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처<br />
          13. 고지의 의무<br />
          <br />
          처리 방침
        </div>
      </div>

      <div>
        <h2 className='title'>1. 공통 및 일반</h2>
        <div className='content'>
        처리목적<br /><br />

        본인확인, 연령확인<br /><br />

        만 13세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인<br /><br />

        금융거래 관련 본인인증 및 금융서비스(충전, 송금, 결제, 적립) 제공<br /><br />

        민원처리, 분쟁해결, 법령상 의무이행을 위한 의사소통 경로 확보<br /><br />

        신규서비스 이용 시 또는 본인인증 시, 보유정보를 이용한 입력편의성 제공<br /><br />

        서비스 관련 공지사항 전달<br /><br />

        서비스 이용현황 통계분석 및 활용<br /><br />

        인구통계학적 특성에 따른 맞춤형 서비스 제공 및 품질 개선<br /><br />

        부정이용방지(금융사기 방지, 이상거래 탐지를 효율적으로 관리하기 위한 목적, 부정거래에 대한 조회/확인, 보이스피싱 관련 조회/확인, 리워드 중복 수령 방지 및 어뷰징 방지), 사고조사, 보안정책 수립<br /><br />

        처리항목<br /><br />

        이름, 생년월일, 성별, 휴대전화번호, 이메일주소, CI(연계정보), DI(중복가입확인정보), 내/외국인 여부, 국적, 고객식별값<br /><br />

        ※ 서비스 이용중 생성된 다양한 개인정보와 자동생성정보가 이용될 수 있습니다<br /><br />

        ※ 만 13세 미만의 부정 사용 감지 시, 법정대리인에게 안내 푸시 또는 문자를 발송할 수 있고, 이는 마케팅 목적이 아닙니다.<br /><br />
        </div>
      </div>

      <div>
        <h2 className='title'>연락처 수집 목적 및 처리 방침</h2>
        <div className='content'>
          "보내기(송금)" 을 하기 위해서는 디바이스 내 연락처 정보를 서버에 전송하고, 앱 내 고객의 동의를 구하고, 보낼 대상을 <br />
          지정 하고, 금액을 송금합니다.<br />
          이 때, 전송된 연락처 정보는 서버에 저장되지 않습니다. <br />

          "패밀리 추가(송금)" 을 하기 위해서는 디바이스 내 연락처 정보를 서버에 전송하고, 앱 내 고객의 동의를 구하고, 패밀리로 <br />
          추가할 대상을 지정 합니다. 추가를 한 패밀리 정보는 앱 내 에서 빠르게 송금이 가능 합니다.<br />
          이 때, 전송된 연락처 정보는 서버에 저장되지 않습니다. <br /><br />
          
          [개인정보의 수집 방법]<br />
          1. 앱 내에서 고객이 직접 입력 및 동의한 정보<br />
          2. 앱 내 조회서비스를 통해 고객이 조회한 정보<br />
          3. 특정 서비스의 사용을 위해서 제휴가사 고객의 사전동의를 받은 후 회사에 제공한 정보<br />
          4. 서비스 이용과정에서 자동으로 수집된 정보<br />

        </div>
      </div>

      <div>
        <h2 className='title'>2. 개인정보 수집에 대한 동의</h2>
        <div className='content'>
        (주)문구야놀자는 이용자들이 회사의 개인정보 처리방침 또는 이용약관의 내용에 대하여 「동의」버튼 또는 「취소」버튼을 클릭할 수 있는 절차를 마련하여, 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
        </div>
      </div>

      <div>
        <h2 className='title'>3. 개인정보의 수집목적 및 이용목적</h2>
        <div className='content'>
          "개인정보"라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.<br />
          서비스는 별도의 사용자 등록이 없이 언제든지 사용할 수 있습니다.<br />
          (주)문구야놀자는 이용자의 사전 동의 없이는 이용자의 개인 정보를 공개하지 않으며, 수집된 정보는 아래와 같이 이용하고 있습니다.<br /><br />

          첫째, 이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다.<br />
          (주)문구야놀자는 신규 서비스개발이나 컨텐츠의 확충 시에 기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할 서비스의 우선 순위를 보다 더 효율적으로 정하고, (주)문구야놀자는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.<br /><br />

          둘째, 수집하는 개인정보 항목과 수집 및 이용목적은 다음과 같습니다.<br />
          - 성명 : 서비스 이용에 따른 본인 확인 절차에 이용<br />
          - 이메일주소, 전화번호 : 고지사항 전달, 불만처리 등을 위한 원활한 의사소통 경로의 확보, 새로운 서비스 및 신상품이나 이벤트 정보 등의 안내<br />
          - 위치 : 인근 가맹점 정보 조회 및 검색<br />
          - 생년월일, 성별 : 성별 및 연령대 별 서비스 제공 확보<br />
          - 연락처: 서비스 내 기능 활용을 위한 접근 허용, 앱 내 콘텐츠의 용이한 활용 서비스 제공<br />

          - 주소록 : 패밀리를 추가하거나, 타인에게 페이 머니를 송금할 시, 특정 대상의 연락처 정보 제공<br />
                
          1) 주소록에 있는 사용자들 중 문구야놀자 앱을 설치<br />
          2) 문구야놀자 앱에 카드를 설치<br />
                      
          상위 조건을 만족하는 사용자의 연락처 정보만 제공되며, 전체 주소록의 연락처 정보는 제공되지 않습니다.<br />
          해당 정보는, 이용자 간의 용이한 페이 서비스 활용을 위해 제공되는 정보입니다.<br />
          문구야놀자 앱을 사용하여 상호 간에 서비스를 이용 및 제공할 수 있는 사용자들끼리의 효율성과 편의성 증대를 위해 제공되며, 페이 서비스를 원활하게 사용하기 위한 이외의 용도로는 활용되지 않습니다.<br />
        </div>
      </div>

      <div>
        <h2 className='title'>4. 수집하는 개인정보 항목 및 수집방법</h2>
        <div className='content'>
          (주)문구야놀자는 이용자들이 서비스를 이용하기 위해 서비스 제공을 위한 필수적인 정보들을 온라인상에서 입력 받고 있습니다. 필수적인 정보는 이름, 이메일 주소 등입니다. 또한 양질의 서비스 제공을 위하여 이용자들이 전화번호 등을 입력 받고 있습니다.<br />
          또한 쇼핑몰 내에서의 설문조사나 이벤트 행사 시 통계분석이나 경품제공 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다. 그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다.<br />
          그리고, 어떤 경우에라도 입력하신 정보를 이용자들에게 사전에 밝힌 목적 이외에 다른 목적으로는 사용하지 않으며 외부로 유출하지 않습니다.<br />
        </div>
      </div>

      <div>
        <h2 className='title'>5. 수집하는 개인정보의 보유 및 이용기간</h2>
        <div className='content'>
          "3. 수집하는 개인정보 항목 및 수집방법"에서와 같이 일시적인 목적 (설문조사, 이벤트, 본인확인 등)으로 입력 받은 개인정보는 그 목적이 달성된 이후에는 동일한 방법으로 사후 재생이 가능한 상태로 처리됩니다.<br />
          귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기하는 것을 원칙으로 합니다. 그리고 상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 (주)문구야놀자는 관계법령에서 정한 일정한 기간 동안 정보를 보관합니다.<br />
          이 경우 (주)문구야놀자는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.<br /><br />

          - 계약 또는 청약철회 등에 관한 기록 : 5년<br />
          - 대금결제 및 재화 등의 공급에 관한 기록 : 5년<br />
          - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년<br />
          (주)문구야놀자는 귀중한 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여 개인정보를 파기합니다.<br /><br />

          - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.<br />
          - 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다<br />
        </div>
      </div>

      <div>
        <h2 className='title'>6. 수집한 개인정보의 공유 및 제공</h2>
        <div className='content'>
          (주)문구야놀자는 이용자들의 개인정보를 "2. 개인정보의 수집목적 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br />
          - 이용자들이 사전에 공개에 동의한 경우<br />
          - 서비스 제공에 따른 요금정산을 위하여 필요한 경우<br />
          - 홈페이지에 게시한 서비스 이용 약관 및 기타 회원 서비스 등의 이용약관 또는 운영원칙을 위반한 경우<br />
          - 자사 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우<br />
          - 기타 법에 의해 요구된다고 선의로 판단되는 경우 (ex. 관련법에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등)<br />
          - 통계작성, 학술연구나 시장조사를 위하여 특정개인을 식별할 수 없는 형태로 광고주, 협력업체나 연구단체 등에 제공하는 경우<br />
        </div>
      </div>

      <div>
        <h2 className='title'>7. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항</h2>
        <div className='content'>
          회원님이 원하실 경우 언제라도 당사에서 개인정보를 열람하실 수 있으며 보관된 필수 정보를 수정하실 수 있습니다. 또한 회원 가입 시 요구된 필수 정보 외의 추가 정보는 언제나 열람, 수정, 삭제할 수 있습니다. 회원님의 개인정보 변경 및 삭제와 회원탈퇴는 당사의 고객센터에서 로그인(Login) 후 이용하실 수 있습니다.
        </div>
      </div>

      <div>
        <h2 className='title'>8. 만 13세 미만 아동의 개인정보 처리에 관한 사항</h2>
        <div className='content'>
        회사는 만 13세 미만 아동에 대해 개인정보를 수집할 때 법정대리인의 동의를 얻어 해당 서비스 수행에 필요한 최소한의 개인정보를 수집합니다.<br />

        • 필수항목 : 법정 대리인의 성명, 관계, 연락처<br />

        또한, 회사의 {"<"}처리목적{">"} 관련 홍보를 위해 아동의 개인정보를 수집할 경우에는 법정대리인으로부터 별도의 동의를 얻습니다.<br />

        회사는 만 13세 미만 아동의 개인정보를 수집할 때에는 아동에게 법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수 있으며, 다음 중 하나의 방법으로 적법한 법정대리인이 동의하였는지를 확인합니다.<br />

        동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 개인정보처리자가 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자 메시지로 알리는 방법<br />

        동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 신용카드·직불카드 등의 카드정보를 제공받는 방법<br />

        동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법<br />

        동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하고 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법<br />

        동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법<br />

        전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법<br />

        그 밖에 위와 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법<br />
        </div>
      </div>
      
      <div>
        <h2 className='title'>9. 비회원 고객의 개인정보관리</h2>
        <div className='content'>
          - 당사는 비회원 고객으로 물품 및 서비스 상품의 구매를 하실 수 있습니다. 당사는 비회원 주문의 경우 배송 및 대금 결제, 상품 배송에 반드시 필요한 개인정보만을 고객님께 요청하고 있습니다.<br />
          - 당사에서 비회원으로 구입을 하신 경우 비회원 고객께서 입력하신 지불인 정보 및 수령인 정보는 대금 결제 및 상품 배송에 관련한 용도 외에는 다른 어떠한 용도로도 사용되지 않습니다.<br />
        </div>
      </div>

      <div>
        <h2 className='title'>10. 개인정보의 위탁처리</h2>
        <div className='content'>
          문구야놀자은(는) 서비스 향상을 위해서 귀하의 개인정보를 필요한 경우 동의 등 법률상의 요건을 구비하여 외부에 수집 · 처리 · 관리 등을 위탁하여 처리할 있으며, 제 3자에 게 제공할 수 있습니다.<br />
          - 당사는 개인정보의 처리와 관련하여 아래와 같이 업무를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 또한 공유하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다.<br />
          - 위탁 대상자 : 우체국<br />
          - 위탁업무 내용 : 배송업무<br />
          - 위탁 대상자 : KSPAY(MINT)<br />
          - 위탁업무 내용 : 전자결제<br />
          - 위탁대상자 : 나이스아이디<br />
          - 위탁업무 내용 : 휴대폰본인인증<br />
          - 다만, 아래의 경우에는 예외로 합니다.<br />
          - 개인정보의 처리를 위탁하거나 제공하는 경우에는 수탁자, 수탁범위, 공유 정보의 범위 등에 관한 사항을 서면, 전자우편, 전화 또는 홈페이지를 통해 미리 귀하에게 고지합니다.<br />
        </div>
      </div>

      <div>
        <h2 className='title'>11. 개인정보관련 의견수렴 및 불만처리에 관한 사항</h2>
        <div className='content'>
          당사는 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 하단에 명시한 "10. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처"항을 참고하여 전화나 메일을 통하여 불만사항을 신고할 수 있고, (주)문구야놀자는 이용자들의 신고사항에 대하여 신속하고도 충분한 답변을 해 드릴 것입니다.
        </div>
      </div>

      <div>
        <h2 className='title'>12. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처</h2>
        <div className='content'>
          당사는 귀하가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 경우 개인정보보호책임자가 책임을 집니다.<br />
          특히 공공장소에서 온라인상에서 접속해 있을 경우에는 더욱 유의하셔야 합니다.<br />
          (주)문구야놀자는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보 보호책임자 및 담당자를 지정하고 있고, 연락처는 아래와 같습니다.<br /><br />

          이 름 : 황선금<br />
          소속 / 직위 : 문구야놀자 / 대표<br />
          E-M A I L : gold2020@playmoongu.com<br />
          전 화 번 호 : 02-6356-1500<br />
        </div>
      </div>

      <div>
        <h2 className='title'>13. 고지의 의무</h2>
        <div className='content'>
          현 개인정보처리방침의 내용은 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을 시에는 홈페이지에서 고지할 것입니다.<br />
        </div>
        <div className='content text-right'>개인정보처리방침 시행일자: 2020.12.18</div>
      </div>
    </>
  ) 
}

export default memo(PrivacyPolicyComponent)
